.spinnerContainer {
  display: flex;
  justify-content: center;
  margin-top: var(--dds-spacing-medium-20);
}
